module.exports = __webpack_public_path__ + "img/partner-smart.8fc8a8c1.png";